import { Network } from "@/interfaces/network";
import { ApiVersion, apiVersion } from "@/utils";

const LEVEL_BY_NETWORK_V1: Record<Network, [boolean, boolean, boolean, boolean]> = {
  [Network.NEAR]: [true, true, true, false],

  [Network.BASE]: [true, false, true, false],
  [Network.LINEA]: [true, false, true, false],
  [Network.ARBITRUM]: [true, false, false, false],

  [Network.BSC]: [true, false, true, false],

  [Network.TON]: [true, false, true, false],
  [Network.TON_TESTNET]: [true, false, true, false],
  [Network.SOLANA]: [true, false, true, false],
  [Network.STELLAR]: [true, false, true, false],
  [Network.ETHEREUM]: [true, false, true, false],
};

const LEVEL_BY_NETWORK_V2: Record<Network, [boolean, boolean, boolean, boolean]> = {
  [Network.NEAR]: [false, false, false, false],

  [Network.BASE]: [false, false, false, false],
  [Network.ARBITRUM]: [false, false, false, false],
  [Network.LINEA]: [false, false, false, false],
  [Network.BSC]: [false, false, false, false],

  [Network.TON]: [true, false, false, false],
  [Network.TON_TESTNET]: [true, false, false, false],
  [Network.SOLANA]: [false, false, false, false],
  [Network.STELLAR]: [true, false, true, false],
  [Network.ETHEREUM]: [false, false, false, false],
};

export const LEVEL_BY_NETWORK = apiVersion === ApiVersion.v1 ? LEVEL_BY_NETWORK_V1 : LEVEL_BY_NETWORK_V2;

export const getAvailableLevels = (network: Network) => [...LEVEL_BY_NETWORK[network], true, false];
